import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Chip } from 'up-ops-web-shared-components';
import CurrencyText from '~src/domains/common/components/CurrencyText';
import SplitOfferSelectedTag from './SplitOfferSelecetedTag';
import {
  loanOfferSelectionSelector,
  loanOffersSelector,
  localeSelector,
} from '~src/domains/common/state/commonSelectors';
import * as styles from '~src/styles/domains/accept/components/SplitOfferSelected.module.scss';

const SplitOfferSelected: FunctionComponent = () => {
  const { t } = useTranslation();

  const loanOfferSelection = useSelector(loanOfferSelectionSelector);
  const loanOffers = useSelector(loanOffersSelector);
  const locale = useSelector(localeSelector);
  console.log(styles);

  const selectedLoanOffer = loanOffers.find(
    offer => offer.offer_id === loanOfferSelection,
  );

  return (
    <div
      id='split-offer-selected'
      className={`${styles['new-pp-selected']} ${styles['split-offer-selected']}`}
    >
      <SplitOfferSelectedTag />
      <div className={['col-xs-12 ', styles['new-plan-info']].join(' ')}>
        <div className={`${styles['offer-card-amount-container']}`}>
          <div className={`${styles['offer-card-amount-container-inner']}`}>
            <div className={`${styles['splash-column']}`}>
              <CurrencyText
                data-auto='monthly-payment-amount'
                className={`${styles['monthly-payment-amount']} ${styles['offer-card-bold']} ${styles['header-text']}`}
                value={selectedLoanOffer!.monthly_payment_amount}
                locale={locale}
              />{' '}
              <span
                className={`${styles['offer-card-bold']} ${styles['per-month']} ${styles['header-text']}`}
              >
                {t('accept:offerSelector.perMonth')}
              </span>
            </div>
          </div>
          <Chip
            className={`${styles['offer-card-bold']} ${styles['chip']}`}
            id='loan-terms-chip'
            aria-labelledby='total-num-payments-label'
            label={`${selectedLoanOffer?.number_of_payments} ${t(
              'accept:offerSelector.months',
            )}`}
          />
        </div>
        <div className={`${styles['offer-card-amount-container']}`}>
          <div className={`${styles['offer-card-amount-container-inner']}`}>
            <div
              className={`${styles['splash-column']} ${styles['subheader-txt']}`}
            >
              <span className={`${styles['pp-small-text']}`}>
                {t('accept:splitOfferSelector.selectedOffer.dueToday')}
              </span>
            </div>
          </div>
          <CurrencyText
            data-auto='pay_today'
            className={`${styles['pp-normal-text']} ${styles['gray-text']}`}
            value={selectedLoanOffer!.pay_today}
            locale={locale}
          />
        </div>
        <div className={`${styles['offer-card-amount-container']}`}>
          <div className={`${styles['offer-card-amount-container-inner']}`}>
            <div
              className={`${styles['splash-column']} ${styles['subheader-txt']}`}
            >
              <span className={`${styles['pp-small-text']}`}>
                <Trans
                  i18nKey='accept:splitOfferSelector.selectedOffer.interestWithAPR'
                  t={t}
                  components={{
                    APRComponent: (
                      <CurrencyText
                        value={selectedLoanOffer!.apr}
                        locale={locale}
                        data-auto='apr_percentage'
                        isApr
                        round={selectedLoanOffer!.apr === 0}
                      />
                    ) as JSX.Element,
                  }}
                />
              </span>
            </div>
          </div>
          <CurrencyText
            data-auto='total_interest'
            className={`${styles['pp-normal-text']} ${styles['gray-text']}`}
            value={selectedLoanOffer!.total_interest}
            superscript
            locale={locale}
          />
        </div>
      </div>
      <div>
        <hr className='divider' />
      </div>
      <div className={['col-xs-12 ', styles['new-plan-info']].join(' ')}>
        <div className={`${styles['offer-card-amount-container']}`}>
          <div className={`${styles['offer-card-amount-container-inner']}`}>
            <div className={`${styles['splash-column']}`}>
              <span
                className={`${styles['pp-small-text']} ${styles['offer-card-bold']}`}
              >
                {t('accept:offerSelector.total')}
              </span>
            </div>
          </div>
          <CurrencyText
            data-auto='grand_total'
            className={`${styles['pp-normal-text']} ${styles['monthly-payment-amount']}`}
            value={selectedLoanOffer!.grand_total}
            locale={locale}
          />
        </div>
      </div>
    </div>
  );
};

export default SplitOfferSelected;
